"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = require("socket.io-client");
const isRunningOnLocal_1 = __importDefault(require("./functions/isRunningOnLocal"));
const socket = (0, isRunningOnLocal_1.default)() ? (0, socket_io_client_1.io)(location.href, {
    autoConnect: true
}) : null;
exports.default = socket;
